import React, { useState, useEffect, useId } from 'react';
import { LiaShoppingCartSolid } from "react-icons/lia";
import { connect } from 'react-redux';
import { FaTimes } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import CartChecklist from '../CartChecklist';
import { addItemSolicitud, deleteItemSolicitud } from '../../../redux/actions/solicitud';
import CartItem from '../CartItem';
import styles from './CartDrawer.module.css';

const CartDrawer = ({ carrito,solicitud }) => {
  const cartCheckboxId = useId();
  const [productos, setProductos] = useState([]);
  const location = useLocation();
  const [showCheckList, setShowCheckList] = useState(false);
  const items = carrito.items;
  useEffect(() => {
    if (items) {
      setProductos(items);
    }
  }, [items]);

  const mostrarCheckList = () => {
    setShowCheckList(true);
  };

  const isCarroProductosPage = location.pathname === "/carroproductos";

  const handleCartToggle = () => {
    const checkbox = document.getElementById(cartCheckboxId);
    if (checkbox) {
      checkbox.checked = !checkbox.checked;
    }
  };

  const isConfirmButtonDisabled = productos.length === 0;

  return (
    <>
      {isCarroProductosPage && (
        <label htmlFor={cartCheckboxId} className={styles.cartButton}>
          <LiaShoppingCartSolid size={26} />
          {productos.length > 0 && (
            <span className={styles.cartItemCount}>{productos.length}</span>
          )}
        </label>
      )}
      <input id={cartCheckboxId} type='checkbox' hidden />
      <aside className={styles.cart}>
        <h2>Tienes {productos.length} productos</h2>
        <FaTimes className={styles.iconoCerrar} size={32} onClick={handleCartToggle} />
        <div className={styles.containerProductos}>
          <ul className={styles.listaProductosCarrito}>
            {productos.map((producto) => (
              <CartItem
                key={producto.producto.id}
                producto={producto}
                itemsCarrito={carrito.items}
              />
            ))}
          </ul>
        </div>
        <button 
          className={styles.buttonSiguiente} 
          onClick={mostrarCheckList} 
          disabled={isConfirmButtonDisabled}
        >
          CONFIRMAR SOLICITUD
        </button>
      </aside>
      <CartChecklist mostrarCheckList={showCheckList} setMostrarCheckList={setShowCheckList} />
    </>
  );
};

const mapStateToProps = state => ({
  carrito: state.Solicitud.carrito,
  solicitud: state.Solicitud
});

export default connect(mapStateToProps, {
  addItemSolicitud,
  deleteItemSolicitud
})(CartDrawer);